import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  textWhite: {
    color: 'white',
    textTransform: 'uppercase',
  },
}));

const SolutionSkills = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title={<span className={classes.textWhite}>Skills</span>}
        titleVariant="h1"
        subtitle={<span className={classes.textWhite}>Finding right skills at right time isn’t easy! Its like finding needle in the haystack.</span>}

        disableGutter
        data-aos="fade-up"
      />
    </div>
  );
};

/*
ctaGroup={[
  <Button variant="outlined" color="secondary" size="large">
    See portfolio
  </Button>,
]}
*/

SolutionSkills.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default SolutionSkills;
